import React, { useEffect } from 'react';
import { useGlobalContext } from '@honeycomb/data';
import { TypographyBody, Dialog, ModalContent, ModalHeader, Anchor, Option, Stacker, Skeleton2, TickIcon, } from '@honeycomb/ui-core';
import { masterSortTypes } from './utils';
export function SortResults({ currentSortValue, sortValueOptions, onSortChange, loading = false, }) {
    var _a;
    const { resourceStrings: { SORTBY, RECOMMENDED, PRICECHEAPESTFIRST, CUSTOMERRATINGHIGHESTFIRST, STARRATINGHIGHESTFIRST, PRICENOBRACKETS, CUSTOMERRATINGNOBRACKETS, STARRATINGNOBRACKETS, DURATIONQUICKESTFIRST, DURATIONNOBRACKETS, PRICEHIGHESTFIRST, DEPARTURETIMEEARLIESTFIRST, DEPARTURETIMENOBRACKETS, DEPARTURETIMELATESTFIRST, RETURNTIMEEARLIESTFIRST, RETURNTIMENOBRACKETS, RETURNTIMELATESTFIRST, DURATIONLONGESTFIRST, }, } = useGlobalContext();
    const [open, setOpen] = React.useState(false);
    // We need local state in order to see the radio button change  before the modal closes
    const [localValue, setLocalValue] = React.useState(currentSortValue);
    useEffect(() => {
        if (localValue !== currentSortValue) {
            setLocalValue(currentSortValue);
        }
    }, [localValue, currentSortValue]);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const sortOptions = {
        RECOMMENDED,
        PRICECHEAPESTFIRST,
        CUSTOMERRATINGHIGHESTFIRST,
        STARRATINGHIGHESTFIRST,
        PRICENOBRACKETS,
        CUSTOMERRATINGNOBRACKETS,
        STARRATINGNOBRACKETS,
        DURATIONQUICKESTFIRST,
        DURATIONNOBRACKETS,
        PRICEHIGHESTFIRST,
        DEPARTURETIMEEARLIESTFIRST,
        DEPARTURETIMENOBRACKETS,
        DEPARTURETIMELATESTFIRST,
        RETURNTIMEEARLIESTFIRST,
        RETURNTIMENOBRACKETS,
        RETURNTIMELATESTFIRST,
        DURATIONLONGESTFIRST,
    };
    const handleChange = React.useCallback((newValue) => (_event) => {
        setLocalValue(newValue);
        onSortChange(newValue);
        handleClose();
    }, [onSortChange]);
    if (loading) {
        return (React.createElement(TypographyBody, { component: "div", w: 160 },
            React.createElement(Skeleton2, { variant: "text" })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Stacker, { direction: "row", alignItems: "center", spacing: 1, "data-id": "sorting" },
            React.createElement(TypographyBody, { weight: "semiBold" },
                SORTBY,
                ":"),
            React.createElement(Anchor, { "data-id": "sort-by-selected-options", component: "button", underline: "always", onClick: handleOpen, color: "text.link", weight: "semiBold" }, sortOptions[((_a = masterSortTypes[currentSortValue]) === null || _a === void 0 ? void 0 : _a.shortName) || 'RECOMMENDED'])),
        React.createElement(Dialog, { "data-id": "sort-by-modal", open: open, onClose: handleClose, "aria-labelledby": "sort-dialog-title", size: "s" },
            React.createElement(ModalHeader, { closeButton: true, borderStyle: "none" }, SORTBY),
            React.createElement(ModalContent, { disableGutters: true, px: 1, pb: 4 },
                React.createElement(Stacker, { component: "ul", gap: 1 }, Object.entries(masterSortTypes)
                    .filter(([key]) => sortValueOptions.includes(key))
                    .map(([key, val]) => {
                    const selected = localValue === key;
                    return (React.createElement("li", { key: `sortOptions-${val.name}` },
                        React.createElement(Option, { button: true, selected: localValue === key, onClick: handleChange(key), actionIcon: selected ? React.createElement(TickIcon, null) : undefined, "data-id": `sort-options-${val.name}` }, sortOptions[val.name])));
                }))))));
}
